import { get, includes } from 'lodash';
import { VIP_ACCOUNTS } from 'config/accounts';

export function isFacilityInactive(facility) {
	if (!facility) return false;
	const isHidden = !facility.live || facility.noAvailableUnits;
	return facility.inNetwork && isHidden;
}

export function isVipFacility(facility) {
	const account = VIP_ACCOUNTS[facility.account?.id];

	if (get(account, 'inclusions.length')) {
		const isIncluded = includes(get(account, 'inclusions', []), facility.id);
		return isIncluded && account;
	}
	const isException = includes(get(account, 'exceptions', []), facility.id);
	return !isException && account;
}
